import React, { useEffect } from 'react';
import IvoriMethodMedicalSchoolPage from '../../features/method/IvoriMethodMedicalSchoolPage';

export default function IvoriMethodMedicalSchoolRoute() {
  useEffect(() => {
    document.title = "The IVORI Method — Medical School Interview Pedagogy | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <IvoriMethodMedicalSchoolPage />;
}
